import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useColorStore } from "@/classes/useColorStore.js";
import { resolveThemeComponent } from "@/themes/registry.js";

export function useThemedComponent(slot) {
    const { theme } = storeToRefs(useColorStore());
    return computed(() => resolveThemeComponent(theme.value, slot));
}
